import React, { useContext } from "react";
import SortableAutocompleteInput from "components/FormElements/SortableAutocompleteInput";
import AutocompleteInput from "components/FormElements/AutocompleteInput";
import Label from "components/FormElements/Label";
import { useAuth } from "hooks/Auth";
import { apiGet } from "helpers/Request";
import { transform as authorTransformer } from "schemas/Author";
import { ContentContext } from "context/Content";
import { useSelector } from "react-redux";

function AuthorField(props) {
    const auth = useAuth();
    const { state } = useContext(ContentContext);
    const settings = useSelector((state) => state.contentFlow?.settings);

    if (state.loading) {
        return (
            <div>
                <Label>Authors</Label>
                <div className="mt-1 h-9 w-full animate-pulse rounded bg-gray-300 text-gray-300"></div>
            </div>
        );
    }

    let element = AutocompleteInput;

    if (settings.settings?.ffSortableAuthors === true) {
        element = SortableAutocompleteInput;
    }

    return React.createElement(element, {
        label: "Authors",
        name: "authors",
        id: "authors",
        disabled:
            state.loading ||
            state.performingStateChange ||
            !state.isUserEditable,
        onRequestSearch: async (term) => {
            const items = await apiGet("/v4/search", auth.publication, {
                keyword: term,
                per_page: 10,
                type: "author",
            });

            return authorTransformer(items).map((item) => {
                return {
                    label: item.name,
                    value: item.uuid,
                };
            });
        },
    });

    // return (
    //     <AutocompleteInput
    //         label="Authors"
    //         name="authors"
    //         id="authors"
    //         disabled={
    //             state.loading ||
    //             state.performingStateChange ||
    //             !state.isUserEditable
    //         }
    //         onRequestSearch={async (term) => {
    //             const items = await apiGet("/v4/search", auth.publication, {
    //                 keyword: term,
    //                 per_page: 5,
    //                 type: "author",
    //             });

    //             return authorTransformer(items).map((item) => {
    //                 return {
    //                     label: item.name,
    //                     value: item.uuid,
    //                 };
    //             });
    //         }}
    //     />
    // );
}

export default AuthorField;
